"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bioplague = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const ResourceType_1 = require("../../../ResourceType");
const RemoveResourcesFromCard_1 = require("../../../deferredActions/RemoveResourcesFromCard");
class Bioplague {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.BIOPLAGUE;
        this.description = 'Lose 3 animals, then reduced by influence.';
        this.revealedDelegate = PartyName_1.PartyName.TRANSHUMANS;
        this.currentDelegate = PartyName_1.PartyName.SPOME;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const amountLost = 3 - turmoil.getPlayerInfluence(player);
            if (amountLost > 0) {
                for (let i = 0; i < amountLost; i++) {
                    game.defer(new RemoveResourcesFromCard_1.RemoveResourcesFromCard(player, ResourceType_1.ResourceType.ANIMAL, 1, true, true));
                }
            }
        });
    }
}
exports.Bioplague = Bioplague;
//# sourceMappingURL=Bioplague.js.map